import Vue from 'vue';

export default {
    checkEmail(context, { email }) {
        const url = `v1/users/check-email?email=${encodeURIComponent(email)}`;
        return Vue.$axios.$get(url);
    },

    saveJobAlert(context, data){
        const url = 'v1/users/save-search';
        return Vue.$axios.$put(url, data);
    },

    deleteJobAlert(context, token){
        const url = `v1/users/save-search/${token}`;
        return Vue.$axios.$delete(url);
    },
};